import PersonalCustomerUpgradeModal from "./PersonalCustomerUpgradeModal"

export default PersonalCustomerUpgradeModal
